var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"payment-button",attrs:{"block":"","color":_vm.disabled ? 'rgba(183, 181, 183, 0.46)' : (_vm.color || '#83dc25'),"depressed":"","disabled":_vm.disabled,"loading":_vm.loading,"tile":"","x-large":""},on:{"click":_vm.onClick}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }